import { h, render, Component } from 'preact'

import SortableColumnHeader from './sortable-column-header-component'

const COLUMNS = [
  { name: 'lastname', display: 'NAME', title: 'Player Name' },
  { name: 'team_abbreviations', display: 'TM', title: 'Teams' },
  { name: 'exact_position', display: 'POS', title: 'Position' },
  { name: 'games', display: 'G', title: 'Games played' },
  { name: 'minutes', display: 'M', title: 'Minutes played' },
  { name: 'per48_position_adj_prod', display: 'AJP48', title: 'ADJP48' },
  { name: 'per48_wins_produced', display: 'WP48', title: 'WP48' },
  { name: 'wins_produced', display: 'WP', title: 'Wins Produced' },
  { name: 'per48_points_over_par', display: 'POP48', title: 'Points Over Par per 48' },
  { name: 'per48_points', display: 'PTS', title: 'Points per 48' },
  { name: 'per48_rebounds', display: 'REB', title: 'Rebounds per 48' },
  { name: 'per48_assists', display: 'AST', title: 'Assists per 48' },  
]

export default class SortableTableHeader extends Component {
  render(props, state) {
    const columns = COLUMNS.map((column) => {
      return <SortableColumnHeader column={ column.name }
                                   title={ column.title }
                                   sort={ props.sort }
                                   direction={ props.direction }
                                   displayName={ column.display }
                                   onClick={ props.onSortLinkClick } />
    })
    
    return (
      <thead>
          <tr>
            { columns }
          </tr>
      </thead>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/sortable-table-header-component.js